import { Crosshair, Trophy, Users } from 'lucide-react-native'
import {
  UNDERLINE_TAB_ANIMATION_MS,
  type UnderlineTabDef,
} from '../../ui/UnderlineTabBar'
import type { WorldCupTab } from '../../../src/worldcup/types/worldcup.types'

// Knockout is not a top-level tab — it lives inside the Standings modal's Groups | Knockout toggle.
export const WORLD_CUP_TABS: readonly UnderlineTabDef<WorldCupTab>[] = [
  { key: 'picks', label: 'Picks', Icon: Crosshair },
  { key: 'leaderboard', label: 'Leaderboard', Icon: Trophy },
  { key: 'groups', label: 'Squads', Icon: Users },
]

/** @deprecated Use UNDERLINE_TAB_ANIMATION_MS from `components/ui/UnderlineTabBar` */
export const TAB_ANIMATION_DURATION = UNDERLINE_TAB_ANIMATION_MS

export const TAB_ICON_SIZE = 17
